module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-badge-fill-09f7a07f.svg";